// extracted by mini-css-extract-plugin
export default {"header":"ChatHeader_header__O4LwL","headerTitle":"ChatHeader_headerTitle__Ce5lQ","headerTitleText":"ChatHeader_headerTitleText__dDidh","actions":"ChatHeader_actions__2dO1p"};